import { connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProductsReturnedCount } from 'src/redux/selectors';
import { NoSearchResultsGuard } from '../components/NoSearchResultsGuard';
import { noSearchResultsMessageVisable } from '../modules/actions';

export const mapStateToProps = (state: ReduxApplicationState) => ({
  noSearchResultsReturned: selectProductsReturnedCount(state) === 0,
  searchTerm: state.products.searchTerm,
});

export const mapDispatchToProps = {
  onMessageVisable: noSearchResultsMessageVisable,
};

export const NoSearchResultsGuardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NoSearchResultsGuard);
